import script from "./CoiPageHeader.vue?vue&type=script&setup=true&lang=js"
export * from "./CoiPageHeader.vue?vue&type=script&setup=true&lang=js"

import "./CoiPageHeader.vue?vue&type=style&index=0&id=7bc9e764&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-7bc9e764"]])

export default __exports__